import { commitMutation, graphql } from "react-relay";
import environment from "../Environment";

const mutation = graphql`
    mutation ResetPasswordRequestMutation($input: ResetPasswordRequestInput!) {
        resetPasswordRequest(input: $input) {
            ok
        }
    }
`;

// let folderName = "x Empty";

export default (email, callback) => {
    console.log('Reset password email: ' + email);
    const variables = {
        input: {
            email: email,
        },
    };

    commitMutation(environment, {
        mutation,
        variables,
        onCompleted: (response, errors) => {
            console.log(response);
            console.log(errors);
            if (response.resetPasswordRequest != null) {
                callback();
            } else {
                console.log("Error resetting password!");
            }
        },
        onError: (err) => console.error(err),
    });
};
